import { Link } from "react-router-dom";
import { CalendarDays, Clock3, ArrowRight } from "lucide-react";
import SEO, { breadcrumbSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { SectionHead } from "../components/Cards";
import Reveal from "../components/Reveal";
import { BLOG_POSTS } from "../data/blog";
import { img } from "../data/site";
import { useLang } from "../i18n";

export default function Blog() {
  const { t } = useLang();
  return (
    <>
      <SEO
        title="Rajasthan Travel Blog — Guides & Road Trip Tips"
        description="Rajasthan travel guides from Blue City Taxi: Jodhpur itineraries, road trip routes, best time to visit, and honest taxi tour planning tips from local drivers."
        path="/blog"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }])]}
      />
      <PageHero
        title={t("blogTitle")}
        subtitle={t("blogSub")}
        image={BLOG_POSTS[1].img}
        crumbs={[{ label: "Home", to: "/" }, { label: t("navBlog") }]}
      />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <SectionHead eyebrow={t("blogEyebrow")} title={t("blogTitle")} />
        <div className="mt-12 grid sm:grid-cols-2 gap-7">
          {BLOG_POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 2) * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}>
                <article className="group bg-white rounded-2xl border border-slate-200/80 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full">
                  <div className="relative h-60 overflow-hidden">
                    <img src={img(p.img, 900)} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <span className="absolute top-3 left-3 rounded-full bg-navy/85 text-gold text-[10px] font-extrabold uppercase tracking-widest px-3 py-1.5 backdrop-blur">{p.tag}</span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-[11px] font-semibold text-slate-400">
                      <span className="inline-flex items-center gap-1"><CalendarDays size={12} /> {new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                      <span className="inline-flex items-center gap-1"><Clock3 size={12} /> {p.readTime}</span>
                    </div>
                    <h2 className="mt-2.5 font-heading text-xl font-bold text-navy leading-snug group-hover:text-royal transition-colors">{p.title}</h2>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-royal">
                      {t("readMore")} <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </article>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand title={t("blogCtaTitle")} text={t("blogCtaText")} />
    </>
  );
}
